<!-- 销售打榜 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <jd-title label="基本信息" type="bold"></jd-title>
          <div class="mt20">
            <el-form-item label="活动名称:" required>
              <el-input
                v-model="ruleForm.activityName"
                maxlength="50"
                show-word-limit
                placeholder="请输入活动名称"
                style="width: 400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.startTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :default-time="
                    this.$getDate(30)[0].substring(
                      11,
                      this.$getDate(30)[0].length
                    )
                  "
                  :clearable="false"
                  :disabled="activityData.isStart"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.endTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  @focus="orderFocus"
                  :picker-options="pickerOptionsValueEnd"
                  :default-time="
                    this.$getDate(30)[0].substring(
                      11,
                      this.$getDate(30)[0].length
                    )
                  "
                  :clearable="false"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart && !backgroundOpacity"
                  @click="clearTime()"
                ></i>
                <img
                  v-if="!activityData.isStart && !backgroundOpacity"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
                <span style="color: #fe4d45">{{ timeOut }}</span>
                小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
          </div>
          <!-- 榜单配置 -->
          <jd-title label="榜单配置" type="bold"></jd-title>
          <div class="mt20">
            <el-form-item label="打榜订单规则：" required>
              <div>需满足下方订单规则才算为指定榜单增加能力值</div>
              <div class="mt20 rank-box">
                <el-form-item label="下单时间:" label-width="110px" required>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :picker-options="orderStartPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderStartTimeChange"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.orderEndTime"
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :picker-options="orderEndPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderEndTimeChange"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearOrderTime"
                    ></i>
                    <img
                      v-if="!activityData.isStart"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="ml8">期间内下单</span>
                  <jd-button
                    type="blueText"
                    class="ml8"
                    :disabled="activityData.isStart"
                    @click="syncOrderTime"
                    >同步活动时间</jd-button
                  >
                </el-form-item>
                <el-form-item label="订单状态:" label-width="110px" required>
                  <el-radio-group
                    v-model="ruleDTO.orderStatus"
                    :disabled="activityData.isStart"
                  >
                    <el-radio :label="1">已完成</el-radio>
                    <el-radio :label="0"
                      >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="显示订单信息:" label-width="110px">
                  <el-checkbox-group
                    v-model="ruleDTO.showOrderInfoTypes"
                    :disabled="activityData.isStart"
                  >
                    <el-checkbox :label="0">订单金额</el-checkbox>
                    <el-checkbox :label="1">订单笔数</el-checkbox>
                    <el-checkbox :label="2">订单中购买商品的件数</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <jd-tip class="mb16">
                  <div style="color: red;">订单金额是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。</div>
                </jd-tip>
                <el-form-item label="能力值计算:" label-width="110px" required>
                  <div class="flexc-cen-x">
                    <el-select
                      v-model="ruleDTO.abilityCalculationType"
                      placeholder="请选择"
                      class="select-box"
                      :disabled="activityData.isStart"
                      @change="handleAbility"
                    >
                      <el-option
                        v-for="item in abilityCalculations"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>

                    <el-input
                      v-model="ruleDTO.abilityCalculationValue"
                      placeholder="请输入"
                      :disabled="activityData.isStart"
                      class="ml8 min-input-box"
                      @input="
                        ruleDTO.abilityCalculationValue = getNumberData(
                          1,
                          $event,
                          0,
                          1
                        )
                      "
                    >
                    </el-input>
                    <span class="mlr8">等于</span>
                    <el-input
                      class="min-input-box"
                      v-model="ruleDTO.ability"
                      placeholder="请输入"
                      :disabled="activityData.isStart"
                      @input="ruleDTO.ability = getNumberData(1, $event, 0, 1)"
                    >
                    </el-input>
                    <span class="ml8">能力值</span>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <div class="mt20">
            <el-form-item label="榜单配置：" required>
              <jd-button
                type="blue"
                @click="addRank"
                :disabled="saleRankConfigs.length >= 20"
                >+添加榜单（{{ saleRankConfigs.length }}/20）</jd-button
              >
              <span class="ml8"
                >配置后相同能力值的排序根据配置顺序显示如两个榜单均是1000能力值，那么排序靠前的，排名也会相应靠前</span
              >
              <div class="mt20">
                <el-tabs
                  v-model="rankValue"
                  closable
                  @tab-remove="removeRank"
                  @tab-click="handleRankClick"
                >
                  <el-tab-pane
                    :key="index"
                    v-for="(item, index) in saleRankConfigs"
                    :label="'榜单' + (index + 1)"
                    :name="index + ''"
                  >
                    <div class="rank-box">
                      <el-form-item label="榜单名称：" required>
                        <el-input
                          maxlength="10"
                          show-word-limit
                          v-model="item.name"
                          :disabled="activityData.isStart && item.isEdit"
                          class="max-input-box"
                          placeholder="请输入榜单名称"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="榜单图片：" required>
                        <div class="flexc-cen-x">
                          <el-upload
                            :class="[
                              'img-uploader',
                              item.fileList.length ? 'hide-upload-btn' : '',
                            ]"
                            ref="upload"
                            action="/jd-hd-web/image/upload"
                            :file-list="item.fileList"
                            list-type="picture-card"
                            :disabled="activityData.isStart && item.isEdit"
                            :before-upload="
                              (file) => beforeUploadList(file, item)
                            "
                            :on-success="
                              (file) => {
                                return handleUploadList(file, item);
                              }
                            "
                            :on-remove="
                              (file, fileList) => {
                                return handleRemoveList(file, fileList, item);
                              }
                            "
                          >
                            <i class="el-icon-plus img-uploader-icon"></i>
                          </el-upload>
                          <div class="ml8 text-box">
                            <div>建议上传尺寸：142px*142px</div>
                            <div>图片大小：1MB以内</div>
                            <div>格式：jpg、png</div>
                          </div>
                        </div>
                      </el-form-item>
                      <el-form-item label="关联商品：" required>
                        <jd-button
                          type="blue"
                          :disabled="
                            item.goodsList.length >= 10 || goodsLoading
                          "
                          @click="addGoods(index, item)"
                          >添加商品（{{ item.goodsList.length }}/10）</jd-button
                        >
                        <div
                          class="goods-box mt12 flexc"
                          v-if="item.goodsList.length > 0"
                        >
                          <div
                            v-for="(goods, index) in item.goodsList"
                            :key="goods.logo + index"
                            class="goods-item mr16"
                          >
                            <img :src="goods.logo" class="goods-img" />
                            <img
                              v-if="!activityData.isStart && !backgroundOpacity"
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/card-delete-icon.svg"
                              class="del-icon"
                              alt=""
                              @click="deleteGoods(item.goodsList, index)"
                            />
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form-item>
          </div>
          <!-- 活动页配置 -->
          <activityPageSettings
            isShowShopName
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="1624"
            previewKey="url"
            templatekey="imageUrl"
            :isCustomPreview="true"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/销售打榜.psd"
            :isShowDesc="false"
            v-model="customerPaperwork"
          >
            <template #customPreview>
              <rankPreviewDialog
                :ruleDTO="ruleDTO"
                :saleRankConfigs="saleRankConfigs"
                :customerPaperwork="customerPaperwork"
                :backgroundImage="templateObj.url"
              />
            </template>
            <template #otherSet>
              <el-form-item
                label="为TA打榜按钮背景颜色（渐变色左）："
                label-width="260px"
              >
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.btnRankLeftColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.btnRankLeftColor = currrentRgb"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>

              <el-form-item
                label="为TA打榜按钮背景颜色（渐变色右）："
                label-width="260px"
              >
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.btnRankRightColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.btnRankRightColor = currrentRgb2"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>

              <el-form-item label="为TA打榜按钮文字颜色：" label-width="260px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.btnRankWordColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.btnRankWordColor = currrentRgb3"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>

              <el-form-item label="自定义排行榜图标：" label-width="260px">
                <div class="flexc">
                  <jd-button type="blueText" @click="handleResetIcon"
                    >重置</jd-button
                  >
                  <div class="ml8 size-box">建议尺寸：68px*68px</div>
                  <div class="tip-box ml8">
                    注：点击重置恢复模板默认的排名ICON，第4名开始后续排名为固定样式
                  </div>
                </div>
                <div class="rank-box flexc">
                  <div class="icon-item">
                    <el-upload
                      :class="[
                        'icon-uploader',
                        iconList.length ? 'hide-upload-btn' : '',
                      ]"
                      ref="upload"
                      action="/jd-hd-web/image/upload"
                      :file-list="iconList"
                      list-type="picture-card"
                      :disabled="backgroundOpacity"
                      :before-upload="(file) => beforeUploadIcon1(file)"
                      :on-success="
                        (file) => {
                          return handleUploadIcon(file, 1);
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          return handleRemoveIcon(file, fileList, 1);
                        }
                      "
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <span>第一名</span>
                  </div>
                  <div class="icon-item">
                    <el-upload
                      :class="[
                        'icon-uploader',
                        iconList2.length ? 'hide-upload-btn' : '',
                      ]"
                      ref="upload"
                      action="/jd-hd-web/image/upload"
                      :file-list="iconList2"
                      list-type="picture-card"
                      :disabled="backgroundOpacity"
                      :before-upload="(file) => beforeUploadIcon2(file)"
                      :on-success="
                        (file) => {
                          return handleUploadIcon(file, 2);
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          return handleRemoveIcon(file, fileList, 2);
                        }
                      "
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <span>第二名</span>
                  </div>
                  <div class="icon-item">
                    <el-upload
                      :class="[
                        'icon-uploader',
                        iconList3.length ? 'hide-upload-btn' : '',
                      ]"
                      ref="upload"
                      action="/jd-hd-web/image/upload"
                      :file-list="iconList3"
                      list-type="picture-card"
                      :disabled="backgroundOpacity"
                      :before-upload="(file) => beforeUploadIcon3(file)"
                      :on-success="
                        (file) => {
                          return handleUploadIcon(file, 3);
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          return handleRemoveIcon(file, fileList, 3);
                        }
                      "
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <span>第三名</span>
                  </div>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>

          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :needIsForceRemind="false"
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 关联商品弹窗 -->
    <selectGoodsMonitor
      v-if="isShowGoods"
      ref="selectGoFilterOne"
      :isShow="isShowGoods"
      @close="getSelectGoods"
      :selectGoods="currentSelectGoods"
      :hasSelectGoods="hasSelectGoods"
      :isClear="activityData.isStart"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="10"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import addTaskDialog from "./components/unlock_task_dialog.vue";
import previewPageDialog from "./components/preview_page_dialog.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import rankPreviewDialog from "./components/newActPreviews/rank-preview-dialog.vue";
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    SelectGoods,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    addTaskDialog,
    previewPageDialog,
    selectGoodsMonitor,
    rankPreviewDialog,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    'ruleForm.endTime': {
      handler(newValue, oldVal) {
        if (!newValue) return;
        const now = new Date();
        const endTime = new Date(newValue);
        // 判断是否为当天
        const isSameDay = endTime.getFullYear() === now.getFullYear() &&
                         endTime.getMonth() === now.getMonth() &&
                         endTime.getDate() === now.getDate();
        console.log(isSameDay,'isSameDay');
       if(!isSameDay){
                console.log(2222222,'isSameDay');
         this.pickerOptionsValueEnd.selectableRange = `00:00:00 - 23:59:59`;
        }else{
             // 获取当前时间
            const now = new Date();
            
            // 计算当前时间一小时后
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            const timeStr = oneHourLater.toTimeString().substring(0, 8);
            console.log(timeStr,'8578787');
            
            // 更新结束时间选择器的时分秒范围
            // 注意：由于Element UI的限制，这个更新可能不会立即生效
            // 需要用户重新打开日期选择器
            this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
        }
      },
    }
  },
  data() {
    return {
      hasSelectGoods: [],
      goodsLoading: false,
      timeDay: 0,
      timeOut: 0,
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      iconList: [],
      iconList2: [],
      iconList3: [],
      designSpecificationsUrl: "",
      currentIndex: 0,
      currentSelectGoods: [],
      isShowGoods: false,
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleDTO.orderEndTime) {
            return (
              time.getTime() >
              new Date(this.ruleDTO.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return false;
          }
        },
      },
      orderEndPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.ruleDTO.orderStartTime &&
              time.getTime() <
                new Date(this.ruleDTO.orderStartTime).valueOf()) ||
            (this.ruleForm.endTime &&
              time.getTime() > new Date(this.ruleForm.endTime).valueOf())
          );
        },
        // selectableRange: (() => {
        //   let data = new Date();
        //   let hour = data.getHours();
        //   let minute = data.getMinutes();
        //   let second = data.getSeconds();
        //   return [`"00:00:00" - ${hour}:${minute}:${second}`];
        // })(),
      },
      // 活动时间选择器禁用日期
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()- 8.64e7 
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        // 默认不限制时间范围
        selectableRange: "00:00:00 - 23:59:59",
      },
      // 榜单规则配置
      rankValue: "0",
      saleRankConfigs: [
        {
          name: "",
          picture: "",
          goodsList: [],
          fileList: [],
          isEdit: false,
        },
        {
          name: "",
          picture: "",
          goodsList: [],
          fileList: [],
          isEdit: false,
        },
      ], // 榜单配置列表
      isForceRemind: false,
      isKeyActivity: false,
      placementPosition: [],
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "#AC1C11",
      currrentRgb2: "#570803",
      currrentRgb3: "#ffffff",
      // currrentRgb4: "#e5cbb3",
      icon1Url: "",
      icon2Url: "",
      icon3Url: "",
      customerPaperwork: {
        title: "明星打榜", //活动主题
        titleColor: "#191919", //主题文字颜色:
        btnRankLeftColor: "#AC1C11", //为TA打榜按钮背景颜色（渐变色左）
        btnRankRightColor: "#570803", //为TA打榜按钮背景颜色（渐变色右）
        btnRankWordColor: "#ffffff", //为TA打榜按钮文字颜色
        // energyBarColor: "#e5cbb3", // 能量条颜色
        icon1Url: "", //排行1图标
        icon2Url: "", //排行2图标
        icon3Url: "", //排行3图标
      },
      templateId: "",
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        activityName: "",
        startTime: "",
        endTime: "",
        ruleDescription: "",
        isExposureItem: false,
      },
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
        orderStartTime: "", // 订单开始时间
        orderEndTime: "", // 订单结束时间
        orderStatus: 1, // 订单状态 1：已完成 0：已付款
        showOrderInfoTypes: [0, 1, 2],
        abilityCalculationType: 0,
        abilityCalculationValue: "",
        ability: "",
      },
      abilityCalculations: [
        {
          value: 0,
          label: "订单金额",
        },
        {
          value: 1,
          label: "订单笔数",
        },
        {
          value: 2,
          label: "商品件数",
        },
      ],
      sharePic: "",
      templateJson: {
        templateUItype: "",
      },

      isDraft: false,
    };
  },
  computed: {
    // 获取任务类型
    getTaskType() {
      return (arr, row) => {
        const obj = arr.find((item) => item.value == row.taskType);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const {
          taskType,
          taskCondition,
          itemStartCount,
          orderStartPayment,
          orderType,
        } = item;
        let str = taskCondition;
        if (taskType == 3 || taskType == 13) {
          str = `成功浏览${taskCondition}件商品`;
        } else if (taskType == 12) {
          str = `成功预约${taskCondition}件商品`;
        } else if (taskType == 17) {
          str = `在规定时间范围内，购买商品大于等于：${
            itemStartCount ? `${itemStartCount}件` : ""
          }${
            orderStartPayment ? `${orderStartPayment}元` : ""
          }，且订单状态为：${orderType == 1 ? "已完成" : "已付款"}`;
        }
        return str;
      };
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(67);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getDetail();
    this.buriedPoint(1, "销售打榜", "互动管理", "互动活动");
  },

  methods: {
    // 点击下单时间显示提示，同时动态设置时分秒选择范围
    orderFocus() {
            
            // 获取当前时间
            const now = new Date();
            
            // 计算当前时间一小时后
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            const timeStr = oneHourLater.toTimeString().substring(0, 8);
            console.log(timeStr,'8578787');
            
            // 更新结束时间选择器的时分秒范围
            // 注意：由于Element UI的限制，这个更新可能不会立即生效
            // 需要用户重新打开日期选择器
            this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
    },
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    handleAbility(val) {
      this.ruleDTO.abilityCalculationValue = "";
      this.ruleDTO.endTime = "";
    },
    // 同步活动时间
    syncOrderTime() {
      this.ruleDTO.orderStartTime = this.ruleForm.startTime;
      this.ruleDTO.orderEndTime = this.ruleForm.endTime;
    },
    handleResetIcon() {
      this.customerPaperwork.icon1Url = this.icon1Url;
      this.customerPaperwork.icon2Url = this.icon2Url;
      this.customerPaperwork.icon3Url = this.icon3Url;
      this.iconList = [{ url: this.icon1Url }];
      this.iconList2 = [{ url: this.icon2Url }];
      this.iconList3 = [{ url: this.icon3Url }];
    },
    checkSameProduct(data, current) {
      let otherList = [];
      let currentObj = null;
      let arr1 = data.map((item) => item.skuId);
      let arr2 = this.saleRankConfigs[current].goodsList.map(
        (item) => item.skuId
      );
      otherList = arr1.filter((item) => !arr2.includes(item));
      let hasDuplicate = this.saleRankConfigs.some((item, index) => {
        return item.goodsList.some((row) => {
          if (otherList.includes(row.skuId)) {
            currentObj = row;
            return true;
          } else {
            return false;
          }
        });
      });

      if (hasDuplicate) {
        this.$message.warning(
          `该榜单所选商品中存在已被其他榜单关联的商品：${
            currentObj.skuName || currentObj.wareTitle
          }，请重新选择商品`
        );
      }
      return hasDuplicate;
    },
    deleteGoods(list, index) {
      if (this.activityData.isStart || this.backgroundOpacity) {
        return;
      }
      list.splice(index, 1);
    },
    addGoods(index, row) {
      this.isShowGoods = true;
      this.currentIndex = index;
      this.currentSelectGoods = row.goodsList;
      if (this.activityData.isStart) {
        this.hasSelectGoods = row.hasSelectGoods;
      }
    },
    getSelectGoods(data) {
      if (data) {
        // 关联商品校验
        let productList = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.skuName = data[index].wareTitle || data[index].title;
          productList.push(fomeVaule);
        });
        if (this.checkSameProduct(data, this.currentIndex)) {
          return;
        } else {
          this.$set(
            this.saleRankConfigs[this.currentIndex],
            "goodsList",
            productList
          );
          this.isShowGoods = false;
        }
      } else {
        this.isShowGoods = false;
      }
    },
    addRank() {
      if (this.saleRankConfigs.length >= 20) {
        this.$message.warning("最多配置20个榜单");
        return;
      }
      this.saleRankConfigs.push({
        name: "",
        picture: "",
        goodsList: [],
        fileList: [],
        isEdit: false,
      });
    },
    removeRank(index) {
      if (this.saleRankConfigs.length <= 2) {
        this.$message.warning("至少配置2个榜单");
        return;
      }
      if (this.saleRankConfigs[index].isEdit) {
        this.$message.warning("已经保存的榜单不可删除");
        return;
      }
      this.saleRankConfigs.splice(index, 1);
      if (index == this.rankValue) {
        this.rankValue = index == 0 ? "0" : index - 1 + "";
      } else if (index < this.rankValue) {
        this.rankValue = this.rankValue - 1 + "";
      }
    },
    clearOrderTime() {
      this.ruleDTO.orderStartTime = "";
      this.ruleDTO.orderEndTime = "";
    },
    // 活动时间改变
    activityTimeChange() {
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        let nowTime = new Date().getTime();
        let start = new Date(this.ruleForm.startTime).valueOf();
        let end = new Date(this.ruleForm.endTime).valueOf();
        let invalidateDate = new Date(
          this.$store.getters.pointUserInfo.expiredIn
        ).valueOf();
        let hdInvalidateDate = new Date(
          this.$store.getters.loginUserInfo.expiresIn
        ).valueOf();
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );
        //计算小时
        const date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        const leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
        // 查看不需要校验
        if (!this.backgroundOpacity) {
          if (start < nowTime) {
            if (this.ids) {
              this.disableTime = true;
            } else {
            }
          }
          if (end < nowTime) {
            this.$message.warning("结束时间不能小于当前时间");
          }
          if (end < start) {
            this.$message.warning("结束时间不能小于开始时间");
            return;
          }
          if (end > invalidateDate) {
            this.$message.warning("活动时间不能超过软件有效期，请重新选择");
            this.ruleForm.endTime = null;
            return;
          }
          if (end > hdInvalidateDate) {
            this.$message.warning("活动时间不可超过互动数据授权有效期！");
            this.ruleForm.endTime = null;
            return;
          }
        }
      }
    },
    // 奖品logo校验
    async beforeUploadList(file) {
      const status = await this.imgchecked(file, 142, 142);
      if (!status) {
        return false;
      }
    },
    // 按钮图标校验
    async beforeUploadIcon1(file) {
      const status = await this.imgchecked(file, 68, 68);
      if (!status) {
        return false;
      }
    },
    async beforeUploadIcon2(file) {
      const status = await this.imgchecked(file, 68, 68);
      if (!status) {
        return false;
      }
    },
    async beforeUploadIcon3(file) {
      const status = await this.imgchecked(file, 68, 68);
      if (!status) {
        return false;
      }
    },

    // 按钮图标上传
    handleUploadIcon(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.icon1Url = res.data;
          this.iconList = [{ url: res.data }];
        } else if (type == 2) {
          this.customerPaperwork.icon2Url = res.data;
          this.iconList2 = [{ url: res.data }];
        } else if (type == 3) {
          this.customerPaperwork.icon3Url = res.data;
          this.iconList3 = [{ url: res.data }];
        }
        this.$message.success(`排行${type}图标上传成功`);
      }
    },
    handleRemoveIcon(file, fileList, type) {
      if (type == 1) {
        this.customerPaperwork.icon1Url = "";
        this.iconList = [];
      } else if (type == 2) {
        this.customerPaperwork.icon2Url = "";
        this.iconList2 = [];
      } else if (type == 3) {
        this.customerPaperwork.icon3Url = "";
        this.iconList3 = [];
      }
    },
    // 打榜图上传
    handleUploadList(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.picture = res.data;
        row.fileList = [{ url: res.data }];
        this.$message.success("榜单图片上传成功");
      }
    },
    // 打榜图移除
    handleRemoveList(file, fileList, row) {
      row.picture = "";
      row.fileList = [];
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isLt1M = file.size < 1024 * 1024;
      return new Promise((resolve, reject) => {
        if (!sorts.includes(type)) {
          this.$message.info("所选文件格式不符，请重新选择");
          reject();
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB");
          reject();
        }
        let _this = this;

        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    initCustomizeData(row) {
      this.customerPaperwork.btnRankLeftColor = row.rgb;
      this.customerPaperwork.btnRankRightColor = row.rgb2;
      this.customerPaperwork.btnRankWordColor = row.rgb3;
      // this.customerPaperwork.energyBarColor =
      //   row.configJson && JSON.parse(row.configJson).rgb4;
      this.customerPaperwork.icon1Url =
        row.configJson && JSON.parse(row.configJson).icon1Url;
      this.customerPaperwork.icon2Url =
        row.configJson && JSON.parse(row.configJson).icon2Url;
      this.customerPaperwork.icon3Url =
        row.configJson && JSON.parse(row.configJson).icon3Url;
      this.iconList = [{ url: this.customerPaperwork.icon1Url }];
      this.iconList2 = [{ url: this.customerPaperwork.icon2Url }];
      this.iconList3 = [{ url: this.customerPaperwork.icon3Url }];
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      // this.currrentRgb4 = row.configJson && JSON.parse(row.configJson).rgb4;
      this.icon1Url = row.configJson && JSON.parse(row.configJson).icon1Url;
      this.icon2Url = row.configJson && JSON.parse(row.configJson).icon2Url;
      this.icon3Url = row.configJson && JSON.parse(row.configJson).icon3Url;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateObj = this.giftList[0];
        this.templateId = this.templateObj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.customerPaperwork.btnRankLeftColor =
          this.customerPaperwork.btnRankLeftColor;
        this.customerPaperwork.btnRankRightColor =
          this.customerPaperwork.btnRankRightColor;
        this.customerPaperwork.btnRankWordColor =
          this.customerPaperwork.btnRankWordColor;
        this.customerPaperwork.btnRankWordColor =
          this.customerPaperwork.btnRankWordColor;
        this.customerPaperwork.icon1Url = this.customerPaperwork.icon1Url;
        this.customerPaperwork.icon2Url = this.customerPaperwork.icon2Url;
        this.customerPaperwork.icon3Url = this.customerPaperwork.icon3Url;
        this.iconList = [{ url: this.customerPaperwork.icon1Url }];
        this.iconList2 = [{ url: this.customerPaperwork.icon2Url }];
        this.iconList3 = [{ url: this.customerPaperwork.icon3Url }];

        // 重置需要初始模板值
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        // this.currrentRgb4 =
        //   this.templateObj.configJson &&
        //   JSON.parse(this.templateObj.configJson).rgb4;

        this.icon1Url =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson).icon1Url;
        this.icon2Url =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson).icon2Url;
        this.icon3Url =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson).icon3Url;
      }

      this.pageData.total = data.total * 1;
    },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 = "榜单详情：\n",
        text4 = "活动对象：不限",
        text5 = "打榜订单规则：订单满足以下条件将计入榜单能量值\n",
        text6 = "本活动仅用于展示明星产品销售情况，为消费者提供参考，非奖励型活动；\n2.销售数据来源于平台的实际交易数据，数据真实、准确、有效；\n3.本活动解释权归商家所有，如有任何疑问或建议，可通过店铺客服仅限咨询；\n4.规则变动：商家可根据活动实际情况，在法律允许范围内对规则进行变更或解释，相关变动会公布于活动页面。",
        firstText = "一、【活动时间与对象】",
        secondText = "\n二、【榜单统计规则】",
        thirdText = "\n三、【注意事项】";
      //活动名称
      if (this.ruleForm.activityName && this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      if (this.saleRankConfigs.length > 0 && this.saleRankConfigs[0].name) {
        let rankText = ""
        this.saleRankConfigs.forEach((item,index)=>{
          let goodsText = item.goodsList.map((goods)=>goods.skuName).join('、')
          rankText += `（${index+1}）榜单${index+1}：\n榜单名称：${item.name}\n关联商品：${goodsText}`
          if(index<this.saleRankConfigs.length-1){
            rankText += '\n'
          }
        })
        text3+=rankText
      }
      let showOrderInfoTypes = {
        0: "订单金额",
        1: "订单笔数",
        2: "商品件数"
      }
      text5 += `（1）下单时间：仅限在${this.ruleDTO.orderStartTime}-${this.ruleDTO.orderEndTime}期间内下单；\n（2）订单状态：仅统计${this.ruleDTO.orderStatus==1 ? '已完成' : '已付款'}的订单；\n（3）能量值计算：${showOrderInfoTypes[this.ruleDTO.abilityCalculationType]}${this.ruleDTO.abilityCalculationValue}等于${this.ruleDTO.ability}能量值`

      // let Arr1 = [text1, text2,text4, text3];
      let Arr1 = [
        [firstText, text1, text2, text4],
        [secondText, text5, text3],
        [thirdText, text6],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (!this.ruleDTO.orderStartTime || !this.ruleDTO.orderEndTime) {
        this.$message.warning("请选择下单时间");
        return;
      }

      if (
        new Date(this.ruleDTO.orderStartTime).valueOf() >
        new Date(this.ruleForm.endTime).valueOf()
      ) {
        this.$message.warning("下单时间不能晚于活动结束时间");
        return;
      }

      if (this.ruleDTO.abilityCalculationType == 0) {
        if (!this.ruleDTO.abilityCalculationValue) {
          this.$message.warning("请输入订单金额");
          return;
        }
        if (!this.ruleDTO.ability) {
          this.$message.warning("请输入订单金额计算的能力值");
          return;
        }
      }

      if (this.ruleDTO.abilityCalculationType == 1) {
        if (!this.ruleDTO.abilityCalculationValue) {
          this.$message.warning("请输入订单笔数");
          return;
        }
        if (!this.ruleDTO.ability) {
          this.$message.warning("请输入订单笔数计算的能力值");
          return;
        }
      }

      if (this.ruleDTO.abilityCalculationType == 2) {
        if (!this.ruleDTO.abilityCalculationValue) {
          this.$message.warning("请输入商品件数");
          return;
        }
        if (!this.ruleDTO.ability) {
          this.$message.warning("请输入商品件数的件数计算的能力值");
          return;
        }
      }

      // 榜单配置校验
      const flag = this.saleRankConfigs.some((item, index) => {
        if (!item.name || item.name.trim() === "") {
          this.$message.warning(`请输入榜单${index + 1}的名称`);
          return true;
        }
        if (!item.picture || item.picture.trim() === "") {
          this.$message.warning(`请上传榜单${index + 1}的榜单图片`);
          return true;
        }
        if (
          !item.goodsList ||
          item.goodsList.length === 0 ||
          !item.goodsList[0].skuId
        ) {
          this.$message.warning(`请选择榜单${index + 1}关联的商品`);
          return true;
        }
      });
      if (flag) {
        return;
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }

      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      //处理榜数据：将saleRankConfigs中的goodsList中的skuId过滤出来用skuIds接收
      const saleRankConfigsList = JSON.parse(
        JSON.stringify(this.saleRankConfigs)
      );
      const saleRankConfigs = saleRankConfigsList.map((item) => {
        item.skuIds =
          item.goodsList.length > 0
            ? item.goodsList.map((goods) => goods.skuId)
            : [];
        delete item.goodsList;
        delete item.fileList;
        delete item.isEdit;
        return item;
      });
      let ruleDTO = {
        ...this.ruleDTO,
        saleRankConfigs,
        isForceRemind: this.isForceRemind,
      };
      let obj = {
        ...this.ruleForm,
        subType: 67,
        ruleDTO,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };

      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;
      // return
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          // const list = obj.ruleDTO.saleRankConfigs
          // list.map((item,index)=>{
          //   return {
          //     ...item,
          //     taskIndex: index
          //   }
          // })
          // obj.ruleDTO.saleRankConfigs = list
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            activityName: obj.activityName,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              templateId,
              isKeyActivity,
              placementPosition,
            } = res.data;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.isExposureItem = isExposureItem ? true : false;
            this.ruleForm.ruleDescription = ruleDescription;
            this.isForceRemind = ruleDto.isForceRemind;
            this.isKeyActivity = isKeyActivity;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            let reqFn = [];
            this.saleRankConfigs = ruleDto.saleRankConfigs.map(
              (item, index) => {
                let obj = {
                  name: item.name,
                  picture: item.picture,
                  goodsList: [],
                  hasSelectGoods: [],
                  isEdit:
                    this.activityData.isStart || this.backgroundOpacity
                      ? true
                      : false,
                  fileList: item.picture ? [{ url: item.picture }] : [],
                };
                if (item.skuIds.length > 0) {
                  this.goodsLoading = true;
                  reqFn.push(
                    getTaobaoItemListSku({
                      current: 1,
                      size: item.skuIds.length,
                      skuIds: item.skuIds,
                    })
                  );
                  Promise.all(reqFn)
                    .then((res) => {
                      this.goodsLoading = false;
                      obj.goodsList =
                        (res[index].data.records &&
                          res[index].data.records.map((item) => {
                            return {
                              skuId: item.skuId + "",
                              logo: item.logo,
                              skuName: item.skuName,
                              price: item.jdPrice,
                            };
                          })) ||
                        [];
                        obj.hasSelectGoods = obj.goodsList;
                    })
                    .catch(() => {
                      this.goodsLoading = false;
                    });
                }
                return obj;
              }
            );
            this.ruleDTO = ruleDto;
            delete this.ruleDTO.sellerSkuList;
            this.templateId = templateId;
            this.getPolite();
            this.loading = false;

            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
              this.saleRankConfigs = ruleDto.saleRankConfigs.map((item) => {
                let obj = {
                  name: item.name,
                  picture: item.picture,
                  goodsList: [],
                  isEdit: false,
                  fileList: [{ url: item.picture }],
                };
                return obj;
              });
            } else {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
            }
            this.activityTimeChange();
          })
          .catch((res) => {
            this.loading = false;
          });
      } else {
        this.ruleForm.startTime = this.$getDate(30)[0];
        this.ruleForm.endTime = this.$getDate(30)[1];
        this.activityTimeChange();
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .ml8 {
    margin-left: 8px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .tips_red {
    color: #ff4d4f;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }
  .prize_box {
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
    &_middle {
      padding-top: 10px;
    }
    &_step {
      margin-top: 16px;
      &_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 10px;
        background-color: #f0f2f7;
        &__delete {
          cursor: pointer;
        }
      }
      &_center {
        background-color: #fff;
        padding: 10px 0px;
      }
    }
  }
  .btn-bg {
    margin-top: 5px;
    width: 80px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rank-item-bg {
    margin-top: 5px;
    width: 142px;
    height: 142px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e9e9e9;
  }
}

.mt20 {
  margin-top: 20px;
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.mr16 {
  margin-right: 16px;
}

.min-input-box {
  width: 90px;
}

.max-input-box {
  width: 400px;
}

.select-box {
  width: 200px;
}

.text-box {
  font-size: 14px;
  color: #999;
}

.rank-box {
  width: fit-content;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  .goods-box {
    width: 100%;
    border-radius: 4px;
    padding: 16px;
    background-color: #eeeeee;
    .goods-item {
      width: 80px;
      height: 80px;
      position: relative;
      .goods-img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
      }
      .del-icon {
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
        width: 17px;
        height: 12px;
      }
    }
  }
  .img-uploader {
    width: 142px;
    height: 142px;
    position: relative;
    overflow: hidden;
    /deep/ .el-upload {
      width: 142px;
      height: 142px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 100%;
      height: 100%;
      border: none;
      background-color: #fff;
    }
  }
  .hide-upload-btn {
    border: none;
    /deep/ .el-upload--picture-card {
      display: none !important;
    }
  }
  .icon-uploader {
    width: 68px;
    height: 68px;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    /deep/ .el-upload {
      width: 68px;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 100%;
      height: 100%;
      border: none;
      background-color: #fff;
    }
  }

  .icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.tip-box {
  color: #ff4d4f;
}

.size-box {
  font-size: 13px;
  color: #666;
}
/deep/ .el-tabs__nav-wrap {
  display: flex;
  align-items: center;
}
</style>
